module.exports = __webpack_public_path__ + "static/images/equipment-focus-inactive.svg";